module.exports = __webpack_public_path__ + "static/assets/3ede239401bbafee6ea403a022977292.svg";